import React, { useState, useEffect } from "react";
import { useDrag, useDrop } from "react-dnd";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useDispatch } from "react-redux";
import "./banners.scss";
import { Image_Url } from "../../ImageUrl/ImageUrl";


// DraggableRow component for each row in the table
function DraggableRow({ data, index, moveRow, startIndex, onEditClick, handleOpenDeleteConfirmationModal, handleCheckboxChange }) {
    const [, drag] = useDrag({
        type: "TABLE_ROW",
        item: { index },
    });

    const [, drop] = useDrop({
        accept: "TABLE_ROW",
        hover: (draggedItem) => {
            if (draggedItem.index !== index) {
                moveRow(draggedItem.index, index);
                draggedItem.index = index;
            }
        },
    });

    return (
        <tr className="tabletd" ref={(node) => drag(drop(node))}>
            <td>{index + startIndex}</td>
            <td>{data.name}</td>
            <td className="table-td-Link">{data.redirect_url}</td>
            <td>{data.sequence}</td>
            <td>{data.admin_user}</td>
            <td className="flex">
                <img src={Image_Url.EDIT} onClick={() => {
                    onEditClick(data.id);
                }} />
                <img src={Image_Url.DELETE_ICONS} onClick={() => {
                    handleOpenDeleteConfirmationModal(data.id);
                }} />
                <label className="switch">
                    <input type="checkbox" checked={data.is_active} onChange={(e) => handleCheckboxChange(data.id, e.target.checked)} />
                    <span className="slider round"></span>
                </label>
            </td>
        </tr>
    );
};
export default DraggableRow;